// extracted by mini-css-extract-plugin
module.exports = {"MultiLayered":"MultiLayered_MultiLayered__THETq"};